<template>
  <div class="wrapper">
    <Sidebar />
    <div id="content-wrapper" class="d-flex flex-column">
      <div id="content">
        <Topbar />
        <div class="container-fluid">
          <div class="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 class="h3 mb-0 text-gray-800">操作日志</h1>
            <button @click="exportLogs" class="d-none d-sm-inline-block btn btn-sm btn-secondary shadow-sm">
              <i class="bi bi-download"></i> 导出日志
            </button>
          </div>

          <div class="card shadow mb-4">
            <div class="card-header py-3">
              <h6 class="m-0 font-weight-bold text-primary">日志列表</h6>
            </div>
            <div class="card-body">
              <div class="mb-4">
                <div class="row">
                  <div class="col-md-4">
                    <input v-model="filters.user" type="text" class="form-control" placeholder="用户名">
                  </div>
                  <div class="col-md-4">
                    <input v-model="filters.module" type="text" class="form-control" placeholder="模块">
                  </div>
                  <div class="col-md-4">
                    <button @click="filterLogs" class="btn btn-primary">搜索</button>
                    <button @click="resetFilters" class="btn btn-secondary ml-2">重置</button>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-bordered" width="100%" cellspacing="0">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>时间</th>
                      <th>用户</th>
                      <th>IP地址</th>
                      <th>模块</th>
                      <th>操作</th>
                      <th>详情</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="log in filteredLogs" :key="log.id">
                      <td>{{ log.id }}</td>
                      <td>{{ log.time }}</td>
                      <td>{{ log.user }}</td>
                      <td>{{ log.ip }}</td>
                      <td>{{ log.module }}</td>
                      <td>{{ log.action }}</td>
                      <td>{{ log.detail }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer class="sticky-footer bg-white">
        <div class="container my-auto">
          <div class="copyright text-center my-auto">
            <span>Copyright © 2024 管理系统</span>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, reactive } from 'vue'
import Sidebar from '../components/Sidebar.vue'
import Topbar from '../components/Topbar.vue'

const filters = reactive({
  user: '',
  module: ''
})

const logs = ref([
  { id: 1, time: '2024-01-15 14:30:25', user: 'admin', ip: '192.168.1.100', module: '认证', action: '登录系统', detail: '成功登录' },
  { id: 2, time: '2024-01-15 14:25:10', user: 'user1', ip: '192.168.1.101', module: '用户管理', action: '查看用户列表', detail: '查看全部用户' },
  { id: 3, time: '2024-01-15 14:20:33', user: 'admin', ip: '192.168.1.100', module: '角色管理', action: '创建角色', detail: '创建角色: 测试角色' },
  { id: 4, time: '2024-01-15 14:15:45', user: 'user2', ip: '192.168.1.102', module: '组织管理', action: '修改组织信息', detail: '修改组织: 技术部' },
  { id: 5, time: '2024-01-15 14:10:12', user: 'admin', ip: '192.168.1.100', module: '权限管理', action: '分配权限', detail: '为角色分配权限' },
  { id: 6, time: '2024-01-15 13:55:08', user: 'user1', ip: '192.168.1.101', module: '日志管理', action: '查看日志', detail: '查看操作日志' }
])

const filteredLogs = computed(() => {
  return logs.value.filter(log => {
    const matchUser = !filters.user || log.user.includes(filters.user)
    const matchModule = !filters.module || log.module.includes(filters.module)
    return matchUser && matchModule
  })
})

const filterLogs = () => {
  console.log('Filtering logs...')
}

const resetFilters = () => {
  filters.user = ''
  filters.module = ''
}

const exportLogs = () => {
  $message.info('日志导出功能')
}
</script>